const isStaging = process.env.REACT_APP_DEPLOYMENT_ENV !== "production" ? true : false;

const buildLeadLink = (caseId) =>
  `https://${isStaging && `staging.`}chevalier.iusta.io/crm/cases/${caseId}/overview`;

export default buildLeadLink;
